import { render, staticRenderFns } from "./form.vue?vue&type=template&id=1d90c415&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=1d90c415&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90c415",
  null
  
)

export default component.exports